import * as L from 'leaflet';

export interface SpeedLegendOptions {
  position?: 'topleft' | 'topright' | 'bottomleft' | 'bottomright';
  className?: string;
}

export function createSpeedLegend(options?: SpeedLegendOptions): L.Control {
  const defaults: Required<SpeedLegendOptions> = {
    position: 'bottomright',
    className: 'speed-legend-control',
  };
  const opts = { ...defaults, ...(options || {}) };

  const SpeedLegendControl = L.Control.extend({
    onAdd: function () {
      const container = L.DomUtil.create('div', opts.className);

      container.innerHTML = `
        <div style="
          background: white;
          border-radius: 12px;
          box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
          border: 1px solid #e0e0e0;
          padding: 16px;
          min-width: 220px;
          font-family: 'Inter', Arial, sans-serif;
          backdrop-filter: blur(10px);
          background: rgba(255, 255, 255, 0.95);
        ">
          <div style="
            display: flex;
            align-items: center;
            gap: 8px;
            margin-bottom: 16px;
            padding-bottom: 12px;
            border-bottom: 1px solid #f0f0f0;
          ">
            <svg width="16" height="16" fill="#1976d2">
              <use xlink:href="./assets/icons/sprite.svg#speedometer"></use>
            </svg>
            <span style="
              font-weight: 600;
              color: #333;
              font-size: 14px;
            ">Velocidad de Ruta</span>
          </div>
          
          <div style="
            display: flex;
            flex-direction: column;
            gap: 12px;
            margin-bottom: 16px;
          ">
            <div style="
              display: flex;
              align-items: center;
              gap: 12px;
              padding: 8px;
              border-radius: 8px;
              transition: background-color 0.2s ease;
            " onmouseover="this.style.backgroundColor='#f8f9fa'" onmouseout="this.style.backgroundColor='transparent'">
              <div style="
                width: 24px;
                height: 6px;
                border-radius: 3px;
                background: #008744;
                flex-shrink: 0;
              "></div>
              <div style="
                display: flex;
                flex-direction: column;
                gap: 2px;
                flex: 1;
              ">
                <span style="
                  font-weight: 600;
                  color: #333;
                  font-size: 13px;
                ">Baja</span>
                <span style="
                  color: #666;
                  font-size: 11px;
                  font-weight: 500;
                ">0-30 km/h</span>
              </div>
            </div>
            
            <div style="
              display: flex;
              align-items: center;
              gap: 12px;
              padding: 8px;
              border-radius: 8px;
              transition: background-color 0.2s ease;
            " onmouseover="this.style.backgroundColor='#f8f9fa'" onmouseout="this.style.backgroundColor='transparent'">
              <div style="
                width: 24px;
                height: 6px;
                border-radius: 3px;
                background: #ffa700;
                flex-shrink: 0;
              "></div>
              <div style="
                display: flex;
                flex-direction: column;
                gap: 2px;
                flex: 1;
              ">
                <span style="
                  font-weight: 600;
                  color: #333;
                  font-size: 13px;
                ">Media</span>
                <span style="
                  color: #666;
                  font-size: 11px;
                  font-weight: 500;
                ">31-60 km/h</span>
              </div>
            </div>
            
            <div style="
              display: flex;
              align-items: center;
              gap: 12px;
              padding: 8px;
              border-radius: 8px;
              transition: background-color 0.2s ease;
            " onmouseover="this.style.backgroundColor='#f8f9fa'" onmouseout="this.style.backgroundColor='transparent'">
              <div style="
                width: 24px;
                height: 6px;
                border-radius: 3px;
                background: #d62d20;
                flex-shrink: 0;
              "></div>
              <div style="
                display: flex;
                flex-direction: column;
                gap: 2px;
                flex: 1;
              ">
                <span style="
                  font-weight: 600;
                  color: #333;
                  font-size: 13px;
                ">Alta</span>
                <span style="
                  color: #666;
                  font-size: 11px;
                  font-weight: 500;
                ">61+ km/h</span>
              </div>
            </div>
          </div>
        </div>
      `;

      return container;
    },
  });

  return new SpeedLegendControl({ position: opts.position });
}

// Función para obtener el color según la velocidad
export function getSpeedColor(speedKmH: number): {
  color: string;
  weight: number;
} {
  if (speedKmH <= 30) {
    return { color: '#008744', weight: 8 }; // Verde Google
  } else if (speedKmH <= 60) {
    return { color: '#ffa700', weight: 8 }; // Naranja Google
  } else {
    return { color: '#d62d20', weight: 8 }; // Rojo Google
  }
}
